import React from 'react';
import { Box, Text } from '@mafc/trolly';
import { useTranslation } from 'react-i18next';
import { PlasticBag } from '@mafc/icon';

import COLORS from 'theme/colors';
import InfoWrapper from 'common/InfoWrapper/InfoWrapper';
import { ChildInfoWraperStyle } from 'common/InfoWrapper/InfoWrapper.style';
import { PlasticBagPackingInfo } from 'network/response/ICart';
import { getFormattedPrice } from 'utils/price.util';

const RowItem: React.FC<{
  label: string;
  value: string | number;
}> = ({ label, value }) => {
  return (
    <Box display="flex" justifyContent="space-between" mb={1}>
      <Text fontSize={2} fontWeight={3} color={COLORS.BLACK}>
        {label}:
      </Text>

      <Text fontSize={2} fontWeight={6} color={COLORS.BLACK}>
        {value}
      </Text>
    </Box>
  );
};

const SingleUsePackageFees: React.FC<{
  plasticBagPackingInfo: PlasticBagPackingInfo;
  children?: React.ReactNode;
}> = ({ plasticBagPackingInfo, children }) => {
  const {
    calculated,
    quantity,
    totalCharges: { currencyName = '', currencyIso = '', value = 0 } = {},
  } = plasticBagPackingInfo;

  const { t } = useTranslation();
  const isPackagingNotRequired = calculated && value === 0;
  const childInfoKey =
    isPackagingNotRequired || !calculated ? 'informViaEmailSms' : 'refundDescription';
  return (
    <InfoWrapper
      icon={<PlasticBag stroke={COLORS.BLUE} />}
      headingText={t('singleUsePackage.orderPackaging')}
    >
      <Box mb="12px">
        {calculated ? (
          <>
            <RowItem label={t('singleUsePackage.boxNeeded')} value={quantity} />
            <RowItem
              label={t('singleUsePackage.totalPackageFee')}
              value={getFormattedPrice({ currencyIso, currencyName, value }, false, true, true)}
            />
          </>
        ) : (
          <Text color={COLORS.BLACK}>{t('singleUsePackage.unableToEsitmateFee')}</Text>
        )}
      </Box>

      <ChildInfoWraperStyle>
        {isPackagingNotRequired && <Box mb={3}>{t('singleUsePackage.packagingNotRequired')}</Box>}
        {t(`singleUsePackage.${childInfoKey}`)}
      </ChildInfoWraperStyle>
      {children}
    </InfoWrapper>
  );
};

export default SingleUsePackageFees;
